export { default } from 'ember-loading/components/while-loading';
